import React, { useEffect, useRef } from 'react';
var VeltCommentPlayerTimeline = function (props) {
    var totalMediaLength = props.totalMediaLength, offset = props.offset, onCommentClick = props.onCommentClick, shadowDom = props.shadowDom, videoPlayerId = props.videoPlayerId, onReactionClick = props.onReactionClick;
    var ref = useRef();
    var onCommentClickRef = useRef(onCommentClick);
    var onReactionClickRef = useRef(onReactionClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        onReactionClickRef.current = onReactionClick;
    }, [onReactionClick]);
    useEffect(function () {
        var element;
        var handleCommentClick = function (event) {
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleReactionClick = function (event) {
            if (onReactionClickRef.current) {
                onReactionClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCommentClick', handleCommentClick);
                element.addEventListener('onReactionClick', handleReactionClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCommentClick', handleCommentClick);
                element.removeEventListener('onReactionClick', handleReactionClick);
            }
        };
    }, []);
    return (React.createElement("velt-comment-player-timeline", { ref: ref, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "total-media-length": totalMediaLength, offset: offset, "video-player-id": videoPlayerId }));
};
export default VeltCommentPlayerTimeline;
